import {useCallback, useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {
    ButtonType,
    LinkType,
    popupButtonConstants,
    popupLinkConstants,
} from 'desktop/pages/success/components/rateUsSection/constants';
import {setPopupLoading} from 'desktop/pages/success/store/reducers/orderLast/orderLast';
import {isOrderContainsSomeContactLenses} from 'desktop/pages/success/store/selectors/orderItems/orderItems';
import {
    getActivePopup,
    getIsPopupLoading,
    getOrderLastData,
} from 'desktop/pages/success/store/selectors/orderLast/orderLast';
import {orderLastAdapter} from 'features/reviewsPopups/adapters/orderLastAdapter';
import {initPopup} from 'features/reviewsPopups/additionalReviewPopup/additionalReviewPopup';

const usePopupSelectors = () => {
    const isPopupLoading = useSelector(getIsPopupLoading);
    const activePopup = useSelector(getActivePopup);
    const orderLastData = useSelector(getOrderLastData);
    const hasCartContactLenses = useSelector(isOrderContainsSomeContactLenses);

    return {activePopup, hasCartContactLenses, isPopupLoading, orderLastData};
};

/**
 * Custom hook for initializing additional popups
 */
export const useAdditionalPopups = () => {
    const [showReviewPopups, setShowReviewPopups] = useState(false);
    const dispatch = useDispatch();
    const {activePopup, hasCartContactLenses, isPopupLoading, orderLastData} = usePopupSelectors();
    const selectedPopup: ButtonType | LinkType =
        popupButtonConstants[activePopup] || popupLinkConstants[activePopup];

    const setPopupLoadingAction = useCallback(
        (isLoading: boolean) => {
            dispatch(setPopupLoading(isLoading));
        },
        [dispatch],
    );

    const initAdditionalPopups = useCallback(() => {
        if (activePopup && orderLastData.id) {
            initPopup(activePopup, orderLastAdapter(orderLastData), setPopupLoadingAction);
        }
        // orderLastData causes remount because setPopupLoading changes it
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activePopup, setPopupLoadingAction]);

    useEffect(() => {
        if (hasCartContactLenses) initAdditionalPopups();
    }, [hasCartContactLenses, initAdditionalPopups]);

    return {
        initAdditionalPopups,
        isPopupLoading,
        selectedPopup,
        setShowReviewPopups,
        showReviewPopups,
    };
};
